import { useEffect, useState } from 'react';
import { toIsoDate } from '../utils/dateHelpers';

// Comparar dos strings una vez por minuto no cuesta nada; lo que importa es no
// depender de un F5 para cruzar la medianoche.
const CHECK_INTERVAL_MS = 60 * 1000;

/**
 * Fecha de hoy (YYYY-MM-DD, hora local) que se actualiza sola al cambiar el día.
 *
 * La planilla queda abierta de un día para el otro y la máquina se suspende de
 * noche: cualquier consulta, filtro o cálculo que fije "hoy" al montar sigue
 * mostrando los datos de ayer hasta que alguien refresca. Usar esta fecha como
 * dependencia de esos efectos y memos hace que la vista se actualice sola.
 *
 * Devuelve la misma clave que `getFechaSnapshotKey()` de saldosService.
 */
export const useFechaHoy = () => {
    const [fechaHoy, setFechaHoy] = useState(() => toIsoDate(new Date()));

    useEffect(() => {
        const sync = () => setFechaHoy(prev => {
            const actual = toIsoDate(new Date());
            return actual === prev ? prev : actual;
        });

        // El navegador frena los timers de las pestañas en segundo plano y no los
        // corre mientras la máquina está suspendida, así que además de la ronda
        // periódica revalidamos al volver a la pestaña.
        const intervalId = setInterval(sync, CHECK_INTERVAL_MS);
        document.addEventListener('visibilitychange', sync);
        window.addEventListener('focus', sync);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', sync);
            window.removeEventListener('focus', sync);
        };
    }, []);

    return fechaHoy;
};
